/* NORAH · Shows the "$" amounts written in promo texts (announcement bar, cart bundle bar,
   cart carousel title, popup) in the customer's currency, using Shopify's active rate.
   Example: "SAVE $50" -> "SAVE £50" (UK) or "SAVE €47" (EU, if the rate is 0.94).
   To use it in another text, add data-nr-money to the element.
   The conversion is idempotent: each text node / aria-label remembers what it was turned into,
   so re-running (the observer fires on every page change) never converts a value twice. */
(function () {
  var cur = window.Shopify && window.Shopify.currency;
  if (!cur || !cur.active) return;
  var code = cur.active;
  var rate = parseFloat(cur.rate) || 1;
  if (code === 'USD' && rate === 1) return;
  if (typeof WeakMap !== 'function' || window.__nrCurrencyOn) return;

  var SEL = '.announcement-bar__message, .nr-cd__bmsg, .nr-cd__bar-labels, .nr-upsell__heading, .nr-cd__line--discount, .nr-pop, [data-nr-money]';
  var RE = /\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(?:\.\d+)?)/g;
  var nf;
  try {
    nf = new Intl.NumberFormat('en', { style: 'currency', currency: code, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  } catch (e) {
    return;
  }
  window.__nrCurrencyOn = true;

  var seenText = new WeakMap();
  var seenAttr = new WeakMap();

  function conv(m, num, off, str) {
    // "$" with a letter right before it (A$, CA$, US$) is already labelled: leave it alone.
    if (off > 0 && /[A-Za-z]/.test(str.charAt(off - 1))) return m;
    var n = parseFloat(num.replace(/,/g, ''));
    if (isNaN(n)) return m;
    return nf.format(Math.round(n * rate));
  }
  function fix(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentNode;
      if (parent && (parent.nodeName === 'SCRIPT' || parent.nodeName === 'STYLE')) continue;
      var now = node.nodeValue;
      if (seenText.get(node) === now) continue;
      if (now.indexOf('$') === -1) {
        seenText.delete(node);
        continue;
      }
      var out = now.replace(RE, conv);
      seenText.set(node, out);
      if (out !== now) node.nodeValue = out;
    }
    var label = el.getAttribute && el.getAttribute('aria-label');
    if (label && seenAttr.get(el) !== label) {
      if (label.indexOf('$') === -1) {
        seenAttr.delete(el);
      } else {
        var lout = label.replace(RE, conv);
        seenAttr.set(el, lout);
        if (lout !== label) el.setAttribute('aria-label', lout);
      }
    }
  }
  function run(root) {
    (root || document).querySelectorAll(SEL).forEach(fix);
    (root || document).querySelectorAll('.nr-cd__bar[aria-label]').forEach(fix);
  }
  function boot() {
    run();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 30);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
